import { createElement, Fragment } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { RichText, useBlockProps, useInnerBlocksProps, BlockControls } from '@wordpress/block-editor';
import { isRTL, __ } from '@wordpress/i18n';
import { ToolbarButton } from '@wordpress/components';
import { formatOutdent, formatOutdentRTL, formatIndentRTL, formatIndent } from '@wordpress/icons';
import { useMergeRefs } from '@wordpress/compose';
/**
 * Internal dependencies
 */

import { useEnter, useBackspace, useSpace, useIndentListItem, useOutdentListItem, useSplit } from './hooks';

function IndentUI(_ref) {
  let {
    clientId
  } = _ref;
  const [canIndent, indentListItem] = useIndentListItem(clientId);
  const [canOutdent, outdentListItem] = useOutdentListItem(clientId);
  return createElement(Fragment, null, createElement(ToolbarButton, {
    icon: isRTL() ? formatOutdentRTL : formatOutdent,
    title: __('Outdent'),
    describedBy: __('Outdent list item'),
    disabled: !canOutdent,
    onClick: outdentListItem
  }), createElement(ToolbarButton, {
    icon: isRTL() ? formatIndentRTL : formatIndent,
    title: __('Indent'),
    describedBy: __('Indent list item'),
    isDisabled: !canIndent,
    onClick: indentListItem
  }));
}

export default function ListItemEdit(_ref2) {
  let {
    attributes,
    setAttributes,
    mergeBlocks,
    onReplace,
    clientId
  } = _ref2;
  const {
    placeholder,
    content
  } = attributes;
  const blockProps = useBlockProps();
  const innerBlocksProps = useInnerBlocksProps(blockProps, {
    allowedBlocks: ['core/list']
  });
  const useEnterRef = useEnter({
    content,
    clientId
  });
  const useBackspaceRef = useBackspace({
    clientId
  });
  const useSpaceRef = useSpace(clientId);
  const onSplit = useSplit(clientId);
  return createElement(Fragment, null, createElement("li", innerBlocksProps, createElement(RichText, {
    ref: useMergeRefs([useEnterRef, useBackspaceRef, useSpaceRef]),
    identifier: "content",
    tagName: "div",
    onChange: nextContent => setAttributes({
      content: nextContent
    }),
    value: content,
    "aria-label": __('List text'),
    placeholder: placeholder || __('List'),
    onSplit: onSplit,
    onMerge: mergeBlocks,
    onReplace: onReplace
  }), innerBlocksProps.children), createElement(BlockControls, {
    group: "block"
  }, createElement(IndentUI, {
    clientId: clientId
  })));
}
//# sourceMappingURL=edit.js.map